import { render, staticRenderFns } from "./Cat5.vue?vue&type=template&id=bc7b1490"
import script from "./Cat5.vue?vue&type=script&lang=js"
export * from "./Cat5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports